module.exports = __webpack_public_path__ + "img/Monte_Kope_79.5103be09.jpg";